import { render, staticRenderFns } from "./Divvy.vue?vue&type=template&id=4cc4591a&scoped=true&"
import script from "./Divvy.vue?vue&type=script&lang=js&"
export * from "./Divvy.vue?vue&type=script&lang=js&"
import style0 from "./Divvy.vue?vue&type=style&index=0&id=4cc4591a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc4591a",
  null
  
)

export default component.exports